'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utilities/ui';
import NextImage from 'next/image';
import React from 'react';
import cssVariables from '@/cssVariables';
const {
  breakpoints
} = cssVariables;
export const ImageMedia = props => {
  const $ = _c(17);
  const {
    alt: altFromProps,
    fill,
    imgClassName,
    onClick,
    onLoad: onLoadFromProps,
    priority,
    resource,
    size: sizeFromProps,
    src: srcFromProps
  } = props;
  const [, setIsLoading] = React.useState(true);
  if (!srcFromProps && (!resource || typeof resource !== "object" || !resource.url)) {
    return null;
  }
  let width;
  let height;
  let alt = altFromProps || "";
  let src = srcFromProps || "";
  if (!src && resource && typeof resource === "object") {
    const {
      alt: altFromResource,
      height: fullHeight,
      url,
      width: fullWidth
    } = resource;
    width = fullWidth || undefined;
    height = fullHeight || undefined;
    alt = altFromResource || alt;
    if (url) {
      src = `${process.env.NEXT_PUBLIC_SERVER_URL || ""}${url}`;
    }
  }
  if (!src) {
    return null;
  }
  let t0;
  if ($[0] !== sizeFromProps) {
    t0 = sizeFromProps ? sizeFromProps : Object.entries(breakpoints).map(_temp).join(", ");
    $[0] = sizeFromProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sizes = t0;
  const t1 = alt;
  let t2;
  if ($[2] !== imgClassName) {
    t2 = cn(imgClassName);
    $[2] = imgClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !fill ? height : undefined;
  let t4;
  if ($[4] !== onLoadFromProps) {
    t4 = () => {
      setIsLoading(false);
      if (typeof onLoadFromProps === "function") {
        onLoadFromProps();
      }
    };
    $[4] = onLoadFromProps;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !fill ? width : undefined;
  let t6;
  if ($[6] !== alt || $[7] !== fill || $[8] !== onClick || $[9] !== priority || $[10] !== sizes || $[11] !== src || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <NextImage alt={t1} className={t2} fill={fill} height={t3} onClick={onClick} onLoad={t4} priority={priority} quality={90} sizes={sizes} src={src} width={t5} />;
    $[6] = alt;
    $[7] = fill;
    $[8] = onClick;
    $[9] = priority;
    $[10] = sizes;
    $[11] = src;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(t0) {
  const [, value] = t0;
  return `(max-width: ${value}px) ${value}px`;
}